module.exports = __webpack_public_path__ + "static/media/we-media.f4b2902a.png";